import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { duplicatesApi } from '../api/duplicates';

/**
 * Реальные «события» для админа: открытые возможные дубли аккаунтов
 * (GET /admin/duplicates/suspected?status=open). Другого фида бэкенд не отдаёт.
 * Один запрос на оба места — колокольчик в шапке и бейдж «Дубли аккаунтов» в меню.
 */
interface AlertsState {
  /** null — ещё не загружено. */
  suspectedDuplicates: number | null;
  error: boolean;
  reload: () => void;
}

const AlertsContext = createContext<AlertsState>({ suspectedDuplicates: null, error: false, reload: () => {} });

export function AlertsProvider({ children }: { children: React.ReactNode }) {
  const [count, setCount] = useState<number | null>(null);
  const [error, setError] = useState(false);

  const fetchCount = useCallback(
    () =>
      duplicatesApi
        .listSuspected('open')
        .then((list) => {
          setError(false);
          setCount(list.length);
        })
        .catch(() => setError(true)),
    [],
  );

  useEffect(() => {
    void fetchCount();
  }, [fetchCount]);

  const reload = useCallback(() => {
    setError(false);
    void fetchCount();
  }, [fetchCount]);

  const value = useMemo(() => ({ suspectedDuplicates: count, error, reload }), [count, error, reload]);
  return <AlertsContext.Provider value={value}>{children}</AlertsContext.Provider>;
}

export const useAlerts = () => useContext(AlertsContext);
